import {
    Skeleton,
    Text
} from '@chakra-ui/react';
import CardField from '@Modules/fraudManagement/components/CardField';
import { createColumnHelper } from '@tanstack/react-table';

export type THolderReferentialValuesDataTableData = {
  primaryKey: string | number,
  type: string,
  number: string,
  amount?: string,
};

type Props = {
  isLoading: boolean | undefined,
};

const columnHelper =
  createColumnHelper<THolderReferentialValuesDataTableData>();

export function getHolderReferentialValuesDataTableColumns({
  isLoading,
}: Props) {
  
  return [
    columnHelper.accessor('type', {
      id: 'type',
      header: 'Type',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Text textAlign={'right'}>{props.getValue()}</Text>
          </Skeleton>
        );
      },
    }),

    columnHelper.accessor('number', {
      id: 'number',
      header: 'Numéro',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <CardField value={props.getValue()} />
          </Skeleton>
        );
      },
    }),

    columnHelper.accessor('amount', {
      id: 'amount',
      header: 'Montant',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            {props?.getValue() !== undefined && <CardField value={props.getValue()} />}
          </Skeleton>
        );
      },
    }),
  ];
}
